import React from 'react';
import ReactFlow, { Controls, Background, MiniMap, Node, Edge } from 'reactflow';
import 'reactflow/dist/style.css';
import './LineageCanvas.css';
import { EventNode } from './EventNode';

const nodeTypes = { eventNode: EventNode };

const canvasStyle: React.CSSProperties = {
  background: '#1a1a2e',
  width: '100%',
  height: '600px',
  borderRadius: '8px',
};

interface LineageCanvasProps {
  nodes: Node[];
  edges: Edge[];
  onNodeClick: (eventId: string) => void;
  selectedNodeId?: string | null;
}

export function LineageCanvas({ nodes, edges, onNodeClick, selectedNodeId }: LineageCanvasProps) {
  return (
    <div style={canvasStyle}>
      <ReactFlow
        nodes={nodes.map(n => ({
          ...n,
          data: { ...n.data, selected: n.id === selectedNodeId },
        }))}
        edges={edges}
        nodeTypes={nodeTypes}
        onNodeClick={(_, node) => onNodeClick(node.id)}
        fitView
        minZoom={0.3}
        maxZoom={2}
      >
        <Controls />
        <Background color="#2a2a4a" gap={20} size={1} />
        <MiniMap
          nodeColor={(n) => n.data?.color || '#4a6fa5'}
          maskColor="rgba(0,0,0,0.7)"
          style={{ backgroundColor: '#0f0f1e' }}
        />
      </ReactFlow>
    </div>
  );
}
